import { css } from '@emotion/react'
import styled from '@emotion/styled'

const shipmentErrorStyles = ({ theme }) => css`
  label: shipment__error;

  color: ${theme.colors.r600};
`

export const ShipmentError = styled('span')(shipmentErrorStyles)
